
import { computed, defineComponent, PropType } from 'vue';
import { useRouter } from 'vue-router';
import { IGroup, IPartner } from '@/types/interfaces';
import AppLazyImage from '@/components/UI/AppLazyImage.vue';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import { NETWORK_CONTACT_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import { useMessagesStore } from '@/modules/messages/store/messagesStore';

export default defineComponent({
  props: {
    group: { type: Object as () => IGroup, required: true },
    groupType: { type: Number as PropType<NETWORK_CONTACT_TYPES> },
    partner: { type: Object as () => IPartner },
  },
  components: { AppLazyImage },
  setup(props) {
    const spacesStore = useSpacesStore();
    const messagesStore = useMessagesStore();
    const router = useRouter();
    const photoUrl = computed(() => {
      if (props.group.photo?.url) {
        return lowResUrlByViewTypeByUrl(props.group.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/Group.svg');
    });

    function requestToJoinGroup(): void {
      spacesStore.requestToJoinGroup(props.group.id).then(() => {
        // const currentMember = messagesStore.currentConversation?.group?.members.find((item) => item.accountId === props.user.accountId);
        // if (currentMember) {
        //   currentMember.contactStatus = CONTACT_STATUS.REQUEST_SENT;
        // }
      });
    }

    function acceptRequestToGroup(): void {
      if (props.partner?.accountId) {
        spacesStore.acceptRequestToGroup(props.group.id, props.partner.accountId);
      }
    }

    function rejectRequestToGroup(): void {
      if (props.partner?.accountId) {
        spacesStore.rejectRequestToGroup(props.group.id, props.partner.accountId);
      }
    }

    function acceptUserToGroup(): void {
      if (props.partner?.accountId) {
        spacesStore.acceptUserToGroup(props.group.id, props.partner.accountId);
      }
    }

    function rejectUserToGroup(): void {
      if (props.partner?.accountId) {
        spacesStore.rejectUserToGroup(props.group.id, props.partner.accountId);
      }
    }

    function messageGroup() {
      if (props.groupType === NETWORK_CONTACT_TYPES.INVITATION || props.groupType === 9) {
        return;
      }
      router.push(`/messages/group/${props.group.id}`);
    }

    return {
      photoUrl,
      messageGroup,
      acceptRequestToGroup,
      rejectRequestToGroup,
      acceptUserToGroup,
      rejectUserToGroup,
      requestToJoinGroup,
      NETWORK_CONTACT_TYPES,
    };
  },
});
